




















import {Component, Inject} from "vue-property-decorator";
import rn from "../../modules/vRoutedefs";
import CompanyUserRequired from "@/components/CompanyRequired";
import BaseApi from "@/store/modules/base";

@Component
export default class Index extends CompanyUserRequired {
  @Inject()
  baseApi!: BaseApi;

  get contents() {
    return [
      {to: {path: rn.system.integrations.path, query: this.$route.query}, descr: "Oppsett av integrasjoner" },
      {to: {path: rn.system.billing.path, query: this.$route.query}, descr: "Fakturering"},
      {to: {path: rn.system.hseguidelines.path, query: this.$route.query}, descr: "HMS retningslinjer"},
    ];
  }
}
